import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { HTTP_CONTEXT } from 'src/app/helper/class/app-constant';
import { isEmptyObj } from 'src/app/helper/class/utilityHelper';
import { environment } from 'src/environments/environment';
import { downloadHelper } from 'src/app/helper/class/downloadHelper';

@Injectable({
  providedIn: 'root',
})
export class AccountApiService {
  constructor(private http: HttpClient, private downloadHelper: downloadHelper) {}

  downloadAccount(id: any, name: any) {
    const url = `/account/download/${id}`;
    const fileName = `${name || 'Account_Info'}`;
    return this.downloadHelper.downloadApi(url, 'GET', fileName);
  }

  save(data: any) {
    return lastValueFrom(this.http.post(`/account/save`, data));
  }
  getList(ev: any) {
    return lastValueFrom(this.http.post(`/account/getList`, ev));
  }
  getAccountDetails(id: string | number) {
    return lastValueFrom(this.http.get(`/account/get/${id}`));
  }
  closeAccount(data: any, id: any) {
    return lastValueFrom(this.http.post(`/account/accountClose/${id}`, data));
  }
  getListTransaction(ev: any) {
    return lastValueFrom(this.http.post(`/account/getListTransaction`, ev));
  }
  getTransactionById(id) {
    return lastValueFrom(this.http.get(`/account/getTransaction/${id}`));
  }
  saveTransaction(data: any) {
    return lastValueFrom(this.http.post(`/account/newTransaction`, data));
  }
  searchAccount(ev: any = []) {
    return lastValueFrom(this.http.post(`/account/search`,ev)
    );
  }
  troubleshoot(id: any){
    return lastValueFrom(this.http.post(`/account/troubleshoot/${id}`,{}));
  }
  getAccountByStaff(id: any) {
    return lastValueFrom(this.http.get(`/account/getByStaff/${id}/${true}`)); // true =>for active only
  }
  getListSettlement(ev: any) {
    return lastValueFrom(this.http.post(`/account/getListSettlement`, ev));
  }
  getBulkListStaff(data: any) {
    return lastValueFrom(this.http.post(`/account/getListStaff`, data));
  }
  saveSettlement(data: any) {
    return lastValueFrom(this.http.post(`/account/saveSettlement`, data));
  }
  getSettlementDetails(id: any) {
    return lastValueFrom(this.http.get(`/account/getSettlementDetails/${id}`));
  }
  updateSettlement(data: any) {
    return lastValueFrom(this.http.post(`/account/updateSettlement`, data));
  }
  getSettlementByAccount(id: any) {
    return lastValueFrom(
      this.http.get(`/account/getSettlementByAccount/${id}`)
    );
  }
  getListNotification() {
    return lastValueFrom(this.http.get(`/account/getListNotification`));
  }
  getListLog(ev: any) {
    return lastValueFrom(this.http.post(`/account/getListLog`, ev));
  }
  getReportList(data, type: 'DOWNLOAD' | 'API' = 'API') {
    const httpC: any = {
      context: new HttpContext().set(HTTP_CONTEXT.SKIP_SUCCESS, true),
    };
    if (type == 'DOWNLOAD') {
      httpC.responseType = 'blob';
    }
    return lastValueFrom(
      this.http.post(`/account/accountReportList`, data, httpC)
    );
  }

  // Loan EMI tracking layer - additive, see App\Services\Loan\* on the backend.
  getLoanSummary(id: any) {
    return lastValueFrom(this.http.get(`/account/getLoanSummary/${id}`));
  }
  getEmiSchedule(id: any) {
    return lastValueFrom(this.http.get(`/account/getEmiSchedule/${id}`));
  }
  getEmiOverdue(id: any) {
    return lastValueFrom(this.http.get(`/account/getEmiOverdue/${id}`));
  }
  getLoanPaymentHistory(id: any) {
    return lastValueFrom(this.http.get(`/account/getLoanPaymentHistory/${id}`));
  }
  getLoanTopups(id: any) {
    return lastValueFrom(this.http.get(`/account/getLoanTopups/${id}`));
  }
  generateEmiSchedule(id: any, data: any = {}) {
    return lastValueFrom(this.http.post(`/account/generateEmiSchedule/${id}`, data));
  }
  rescheduleEmi(id: any, data: any) {
    return lastValueFrom(this.http.post(`/account/rescheduleEmi/${id}`, data));
  }
  loanPayment(data: any) {
    return lastValueFrom(this.http.post(`/account/loanPayment`, data));
  }
  loanTopup(data: any) {
    return lastValueFrom(this.http.post(`/account/loanTopup`, data));
  }
}
